import * as actions from "./jenisLembaga.actions";
import * as types from "./jenisLembaga.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { JenisLembagaReducerType } from "./types";

export type JenisLembagaActions = ActionType<typeof actions>;

export const initialState: JenisLembagaReducerType = {
  error: null,
  isLoading: false,
  errorMessage: "",
  redirectQueue: '',
  listJenisLembaga: [],
  selectedJenisLembaga: null,
};

export const JenisLembagaReducer = createReducer<
JenisLembagaReducerType,
  JenisLembagaActions
>(initialState)
  // GET JENIS DOKUMEN
  .handleAction(actions.getJenisLembagaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getJenisLembagaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    listJenisLembaga: action.payload.data.items,
  }))
  .handleAction(actions.getJenisLembagaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET JENIS DOKUMEN
  .handleAction(actions.getDetailJenisLembagaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getDetailJenisLembagaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    selectedJenisLembaga: action.payload.data,
  }))
  .handleAction(actions.getDetailJenisLembagaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE JENIS DOKUMEN
  .handleAction(actions.updateJenisLembagaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.updateJenisLembagaAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/jenis-lembaga',
  }))
  .handleAction(actions.updateJenisLembagaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE JENIS DOKUMEN
  .handleAction(actions.createJenisLembagaAsync.request, (state) => ({
    ...state,
    isLoading: true,
    error: null,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.createJenisLembagaAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    error: null,
    errorMessage: '',
    redirectQueue: '/jenis-lembaga',
  }))
  .handleAction(actions.createJenisLembagaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_JENIS_LEMBAGA as any, (state, action) => ({
    ...state,
    selectedJenisLembaga: action.payload.jenisLembaga,
  }))
  .handleAction(types.SELECT_JENIS_LEMBAGA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedJenisLembaga: action.payload.jenisLembaga,
  }))
  .handleAction(types.UPDATE_NAME as any, (state, action) => ({
    ...state,
    selectedJenisLembaga: (() => {
      if (state.selectedJenisLembaga) {
        return {
          ...state.selectedJenisLembaga,
          CO_TYP_NAME: action.payload.name
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedJenisLembaga: (() => {
      if (state.selectedJenisLembaga) {
        return {
          ...state.selectedJenisLembaga,
          STATUS: action.payload.status
        };
      } else {
        return null;
      }
    })(),
  }))
